import { createFileRoute } from "@tanstack/react-router";

import { ForgotPasswordPage } from "../components/auth/ForgotPasswordPage";

/** Requests a password-reset letter; reachable without a session. */
export const Route = createFileRoute("/forgot-password")({
  component: ForgotPasswordPage,
});
